// @flow
export const USER_REQUEST_FETCH = 'USER_REQUEST_FETCH'
export const USER_REQUEST_SUCCESS = 'USER_REQUEST_SUCCESS'
export const USER_REQUEST_FAIL = 'USER_REQUEST_FAIL'
export const USER_REQUEST_LOGOUT = 'USER_REQUEST_LOGOUT'
